import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { IActiveSwitchProps } from "./types";
import Switch from "../../../../components/Switch";

import "./styles.scss";

export const ActiveSwitch: FC<IActiveSwitchProps> = ({ active, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="active-switch">
      {active ? (
        <span className="switch-label active">{t("active")}</span>
      ) : (
        <span className="switch-label inactive">{t("inactive")}</span>
      )}
      <Switch checked={active} onChange={onChange} className="switcher" />
    </div>
  );
};
